import {
  Antrag,
  EinreichungComponentType,
  EinreichungStep,
  EinreichungStepResultType,
} from '@ebeihilfe/einreichung-old';
import { Component, OnInit } from '@angular/core';
import { ConfigSettingsService, Deferred, EinreichungComponents } from '@ebeihilfe/core';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: 'portal-startup-information',
  templateUrl: './startup-information.component.html',
  styleUrls: ['./startup-information.component.scss'],
  standalone: false,
})
export class StartupInformationComponent implements EinreichungComponentType, OnInit {
  public antrag: Antrag;
  public component = StartupInformationComponent;
  public maximumAntragSizeInMb: number;
  public maximumFileSizeInMb: number;
  public name = EinreichungComponents.Startup;
  public prio = EinreichungStep.INIT;
  public work: Deferred<EinreichungStepResultType>;

  constructor(private configService: ConfigSettingsService) {}

  public next(): void {
    this.work.resolve({
      result: this.antrag,
      shouldProceed: true,
    });
  }

  public ngOnInit(): void {
    const { constants } = this.configService.appSettings;
    this.maximumFileSizeInMb = constants.maximumFileSizeInMb;
    this.maximumAntragSizeInMb = constants.maximumAntragSizeInMb;
  }

  public canHandle(): boolean {
    return true;
  }

  public destroy(): Promise<void> {
    return Promise.resolve(undefined);
  }

  public handle(
    antrag: Antrag,
    instance: StartupInformationComponent,
    work: Deferred<EinreichungStepResultType>,
  ): Promise<EinreichungStepResultType> {
    instance.antrag = antrag;
    instance.work = work;
    return instance.work;
  }

  public hasUi(): boolean {
    return true;
  }
}
